import { render, staticRenderFns } from "./room_editor.vue?vue&type=template&id=0e12837c&"
import script from "./room_editor.vue?vue&type=script&lang=js&"
export * from "./room_editor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/planorama/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0e12837c')) {
      api.createRecord('0e12837c', component.options)
    } else {
      api.reload('0e12837c', component.options)
    }
    module.hot.accept("./room_editor.vue?vue&type=template&id=0e12837c&", function () {
      api.rerender('0e12837c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/venues/room_editor.vue"
export default component.exports